import { inject, Injectable } from "@angular/core";
import { FormConfiguration, FormRow } from "pax-ui/components";
import { FormName } from "src/app/shared/models/form-name";
import { FormComponentService } from "src/app/shared/services/form/form-component.service";
import {
  AnsweredAppropriatenessAssessmentQuestion,
  AppropriatenessAssessmentQuestion,
  AppropriatenessAssessmentQuestionId,
} from "src/app/shared/store/quote/shared/shared.state";

@Injectable({
  providedIn: "root",
})
export class AppropriatenessAssessmentFormConfigurationService {
  _formComponentService = inject(FormComponentService);

  createFormModel(
    appropriatenessAssessmentQuestions?: AppropriatenessAssessmentQuestion[],
    appropriatenessAssessmentQuestionAnswers?: AnsweredAppropriatenessAssessmentQuestion[],
  ) {
    const appropriatenessAssessmentQuestionsFormModel: Partial<AppropriatenessAssessmentQuestionsFormModel> =
      {};

    appropriatenessAssessmentQuestions?.forEach(
      (appropriatenessAssessmentQuestion) => {
        const questionAnswer = this.tryGetAnswer(
          appropriatenessAssessmentQuestion,
          appropriatenessAssessmentQuestionAnswers,
        );

        if (questionAnswer?.selectedAnswer !== undefined) {
          appropriatenessAssessmentQuestionsFormModel[
            appropriatenessAssessmentQuestion.id
          ] = questionAnswer.selectedAnswer;
        }
      },
    );

    return appropriatenessAssessmentQuestionsFormModel;
  }

  createFormConfiguration(
    formName: FormName,
    appropriatenessAssessmentQuestions?: AppropriatenessAssessmentQuestion[],
  ) {
    const defaultFormConfiguration: FormConfiguration = {
      name: formName,
      rows: [],
    };

    const formRows = appropriatenessAssessmentQuestions?.map(
      (appropriatenessAssessmentQuestion) => {
        return this.createSingleQuestionFormRow(
          appropriatenessAssessmentQuestion,
        );
      },
    );

    if (formRows) {
      defaultFormConfiguration.rows = formRows;
    }

    return defaultFormConfiguration;
  }

  private createSingleQuestionFormRow(
    appropriatenessAssessmentQuestion: AppropriatenessAssessmentQuestion,
  ) {
    const appropriatenessAssessmentQuestionField =
      this._formComponentService.getAppropriatenessAssessmentQuestionField(
        appropriatenessAssessmentQuestion,
      );

    const formRow: FormRow = {
      items: [appropriatenessAssessmentQuestionField],
    };

    return formRow;
  }

  private tryGetAnswer(
    appropriatenessAssessmentQuestion: AppropriatenessAssessmentQuestion,
    appropriatenessAssessmentQuestionAnswers?: AnsweredAppropriatenessAssessmentQuestion[],
  ) {
    return appropriatenessAssessmentQuestionAnswers?.find(
      (answeredQuestion) =>
        appropriatenessAssessmentQuestion.id === answeredQuestion.questionId,
    );
  }
}

export type AppropriatenessAssessmentQuestionsFormModel = Record<
  AppropriatenessAssessmentQuestionId,
  number
>;
